import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { ConnectWhatsappCoexistenceSchema } from "schema"
import { z } from "zod"
import { settingsWhatsappNumbersQuery } from "../../lib/whatsapp/settingsWhatsappNumbersQuery"

export const useConnectWhatsappCoexistenceMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (data: z.input<typeof ConnectWhatsappCoexistenceSchema>) => {
      await axios.post("/integrations/whatsapp/coexistence/connect", data)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: settingsWhatsappNumbersQuery().queryKey })
    },
  })
}
